const UnlockedFeatureCreditCriteria = {
    creditScoreMinimum: 680,
    grossIncomeMultiplier: 3    // gross yearly income (salary) must be 3 times credit max amt
}
export default UnlockedFeatureCreditCriteria;